import React from 'react'
import { getRevcontentId } from 'utils'
import ClientOnly from 'components/ClientOnly'
import MediaQuery from 'components/MediaQuery'
import ExternalProvider, { providers } from 'components/ExternalProvider'

function _RevcontentWidget({ id, media = { minWidth: 0 } }) {
  return (
    <ClientOnly>
      <MediaQuery {...media}>
        <div
          className='REVCONTENT bs-revcontentWidget'
          data-rc-widget
          data-widget-host='habitat'
          data-endpoint='//trends.revcontent.com'
          data-widget-id={getRevcontentId(id)}
        />
      </MediaQuery>
    </ClientOnly>
  )
}

export default function RevcontentWidget({ ...args }) {
  return (
    <ExternalProvider name={providers.revcontent}>
      <_RevcontentWidget {...args} />
    </ExternalProvider>
  )
}
